module.exports = __webpack_public_path__ + "static/media/MSBadges1.ccd66fba.jpg";